import React, { useState } from "react";
import "./Contact_Form.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Black_btn from "../../common-components/common-button/black-btn/Black_btn";
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocation,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import Successfull_Lottie from "../../animtaion/Successfull_Lottie/Successfull_Lottie";
import Form_component from "./Form_component";

const Contact_Form = () => {
  
  const data = [
    {
      img: faLinkedinIn,
      link: "https://www.linkedin.com/",
    },
    {
      img: faFacebookF,
      link: "https://www.facebook.com",
    },
    {
      img: faXTwitter,
      link: "https://www.twitter.com",
    },
    {
      img: faInstagram,
      link: "https://www.instagram.com",
    },
  ];





  return (
    <section className="Contact_Form enquire_Contact_Form">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 mb-3">
            <Form_component />
          </div>

          <div className="col-lg-5">
            <div className="left_side">
              <div className="contact_div">
                <p className="bold_text">Office</p>

                <div className="row_div">
                  <div className="icon_holder ">
                    <FontAwesomeIcon icon={faLocationDot} className="icon" />
                  </div>
                  <div className="text_content">
                    <p className="light_text">
                      Flat No.102, Rajgad Heights, Phaltan Road, Kasba,
                      Baramati-413102
                    </p>
                  </div>
                </div>

                <div className="row_div">
                  <div className="icon_holder ">
                    <FontAwesomeIcon icon={faPhone} className="icon" />
                  </div>
                  <div className="text_content">
                    <p className="light_text">+91- 8766701045 / 7721091787</p>
                  </div>
                </div>

                <div className="row_div">
                  <div className="icon_holder ">
                    <FontAwesomeIcon icon={faEnvelope} className="icon" />
                  </div>
                  <div className="text_content">
                    <p className="light_text">scroma1001@gmail.com</p>
                  </div>
                </div>
              </div>

              <div className="bottom_div">
                <p className="bold_text">Social Links</p>

                <div className="social_icons_div">
                  {data?.map((item) => {
                    return (
                      <div
                        className="icon_div"
                        onClick={() => {
                          window.open(item?.link, "_blank");
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item?.img}
                          className="icon_img"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="map_section">
          <div className="mapouter">
            <div className="gmap_canvas">
              <iframe
                className={`gmap_iframe`}
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=pune&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              ></iframe>
              <a href="https://pdflist.com/" alt="pdflist.com"></a>
            </div>
          </div>
        </div>
      </div>

      {/* <Success_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        successText="Response Submitted Successfully!"
      /> */}
    </section>
  );
};

export default Contact_Form;
